exports.translationFileNames = [
  '', // base
  'timezones_',
  'integration_directory_',
  'xmapi_',
  'import_validation_',
  'login_',
  'countries_',
  'languages_',
];
